var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _rect3, _rect4, _path7, _path8, _path9, _path0, _path1, _path10, _rect5, _rect6, _path11, _path12, _path13, _path14, _path15, _path16, _rect7, _rect8, _path17, _path18, _path19, _path20, _path21, _path22, _rect9, _rect0, _path23, _path24, _path25, _path26, _path27, _path28, _rect1, _rect10, _path29, _path30, _path31, _path32, _path33, _path34, _rect11, _rect12, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect13, _path42, _path43, _path44, _path45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectiveIntermittentFasting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 150,
    viewBox: "0 0 280 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 139.275,
    y: -1.08335,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(5 139.275 -1.08335)",
    fill: "#F74A4A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 139.275,
    y: -1.08335,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(5 139.275 -1.08335)",
    stroke: "#F2F6FA",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.342 17.165L153.495 22.1149C154.806 23.677 157.135 23.8807 158.697 22.57V22.57C160.259 21.2592 160.463 18.9302 159.152 17.3681L154.999 12.4183",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.902 21.4082V21.4082C153.885 22.5798 155.632 22.7326 156.804 21.7495L158.218 20.5628C159.39 19.5798 159.542 17.8331 158.559 16.6615V16.6615",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.697 22.5703L152.17 14.792",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.849 23.2822L159.546 21.8581L169.605 32.6974L171.979 35.5258C172.634 36.3069 172.532 37.4714 171.751 38.1267V38.1267C170.97 38.7821 169.805 38.6803 169.15 37.8992L166.777 35.0707L157.849 23.2822Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.243 24.27C169.339 25.8675 166.467 25.5796 164.829 23.627C163.19 21.6743 163.406 18.7963 165.309 17.1988C167.213 15.6013 171.549 12.9672 174.021 15.9135C176.494 18.8598 173.147 22.6725 171.243 24.27Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.824 22.1848L166.248 23.8819L155.409 33.9411L152.581 36.3145C151.8 36.9698 150.635 36.868 149.98 36.0869V36.0869C149.324 35.3058 149.426 34.1414 150.207 33.486L153.036 31.1126L164.824 22.1848Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 167.83,
    y: 33.8706,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(8 167.83 33.8706)",
    fill: "#F74A4A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 167.83,
    y: 33.8706,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(8 167.83 33.8706)",
    stroke: "#F2F6FA",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176.927 52.6221L180.815 57.7825C182.043 59.4111 184.358 59.7364 185.986 58.5092V58.5092C187.615 57.282 187.94 54.9669 186.713 53.3383L182.824 48.1779",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M180.26 57.0459V57.0459C181.18 58.2673 182.917 58.5114 184.138 57.5909L185.612 56.4799C186.834 55.5595 187.078 53.8232 186.157 52.6017V52.6017",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M185.987 58.5096L179.876 50.4004",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M185.101 59.1757L186.871 57.8424L196.349 69.1933L198.571 72.1421C199.185 72.9564 199.022 74.1139 198.208 74.7275V74.7275C197.393 75.3411 196.236 75.1784 195.622 74.3642L193.4 71.4153L185.101 59.1757Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M198.427 60.8632C196.442 62.3589 193.589 61.9211 192.055 59.8853C190.521 57.8496 190.887 54.9868 192.872 53.4912C194.856 51.9955 199.324 49.5919 201.639 52.6635C203.954 55.7352 200.412 59.3675 198.427 60.8632Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M192.126 58.4452L193.459 60.2145L182.108 69.6926L179.16 71.9147C178.345 72.5283 177.188 72.3656 176.574 71.5513V71.5513C175.961 70.7371 176.123 69.5795 176.938 68.9659L179.886 66.7438L192.126 58.4452Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80.949,
    y: 3.98437,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-3 80.949 3.98437)",
    fill: "#F74A4A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 80.949,
    y: 3.98437,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-3 80.949 3.98437)",
    stroke: "#F2F6FA",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3672 23.2764L100.969 28.3206C102.737 29.9125 105.461 29.7697 107.053 28.0018V28.0018C108.645 26.2338 108.502 23.51 106.734 21.9181L101.132 16.8739",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M100.169 27.5996V27.5996C101.495 28.7935 103.538 28.6865 104.732 27.3605L106.173 25.7599C107.367 24.4339 107.26 22.3911 105.934 21.1971V21.1971",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M107.053 28.0018L98.25 20.0752",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M106.188 28.9623L107.917 27.0415L121.299 37.9309L124.5 40.8133C125.384 41.6093 125.455 42.9712 124.659 43.8552V43.8552C123.863 44.7392 122.502 44.8105 121.618 44.0146L118.416 41.1322L106.188 28.9623Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.823 27.9273C119.883 30.082 116.519 30.2157 114.309 28.2258C112.099 26.2359 111.88 22.876 113.82 20.7213C115.76 18.5665 120.342 14.8193 123.676 17.8218C127.011 20.8243 123.763 25.7725 121.823 27.9273Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M114.069 26.5609L115.99 28.2903L105.1 41.6717L102.218 44.873C101.422 45.757 100.06 45.8284 99.1761 45.0324V45.0324C98.2921 44.2364 98.2207 42.8746 99.0167 41.9906L101.899 38.7893L114.069 26.5609Z",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 128.577,
    y: 37.9166,
    width: 42,
    height: 42,
    rx: 21,
    transform: "rotate(5 128.577 37.9166)",
    fill: "#F74A4A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 128.577,
    y: 37.9166,
    width: 42,
    height: 42,
    rx: 21,
    transform: "rotate(5 128.577 37.9166)",
    stroke: "#F2F6FA",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M137.118 53.3047L140.579 57.4295C141.672 58.7313 143.612 58.9011 144.914 57.8088V57.8088C146.216 56.7165 146.386 54.7757 145.293 53.4739L141.832 49.3491",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M140.085 56.8398V56.8398C140.904 57.8162 142.36 57.9435 143.336 57.1243L144.515 56.1354C145.491 55.3161 145.618 53.8606 144.799 52.8842V52.8842",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M144.914 57.8091L139.475 51.3271",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M144.207 58.4023L145.621 57.2156L154.004 66.2483L155.981 68.6053C156.528 69.2562 156.443 70.2266 155.792 70.7728V70.7728C155.141 71.3189 154.171 71.234 153.624 70.5832L151.647 68.2261L144.207 58.4023Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M155.37 59.2245C153.783 60.5558 151.39 60.3159 150.025 58.6887C148.659 57.0614 148.839 54.6631 150.425 53.3319C152.012 52.0006 155.625 49.8055 157.685 52.2608C159.745 54.716 156.956 57.8933 155.37 59.2245Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M150.021 57.487L151.207 58.9013L142.175 67.2839L139.818 69.2617C139.167 69.8079 138.196 69.723 137.65 69.0721V69.0721C137.104 68.4212 137.189 67.4508 137.84 66.9047L140.197 64.9269L150.021 57.487Z",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 45.8559,
    y: 40.6775,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(-9 45.8559 40.6775)",
    fill: "#F74A4A"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 45.8559,
    y: 40.6775,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(-9 45.8559 40.6775)",
    stroke: "#F2F6FA",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0391 55.9502L65.2666 59.7482C66.9163 60.9468 69.2254 60.5811 70.424 58.9313V58.9313C71.6226 57.2816 71.2569 54.9725 69.6071 53.7739L64.3796 49.9759",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5195 59.2061V59.2061C65.7568 60.105 67.4886 59.8307 68.3876 58.5934L69.4727 57.0998C70.3717 55.8625 70.0974 54.1307 68.8601 53.2318V53.2318",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4236 58.9312L62.209 52.9629",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7729 59.8274L71.0751 58.0351L83.4577 66.1188L86.4449 68.2891C87.2697 68.8884 87.4526 70.0429 86.8533 70.8678V70.8678C86.254 71.6927 85.0994 71.8755 84.2746 71.2762L81.2874 69.1059L69.7729 59.8274Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0087 57.5441C81.5479 59.5548 78.6919 59.9701 76.6297 58.4718C74.5675 56.9736 74.08 54.129 75.5408 52.1184C77.0016 50.1078 80.5715 46.5029 83.6831 48.7636C86.7947 51.0243 84.4695 55.5335 83.0087 57.5441Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2761 57.0737L78.0684 58.3759L69.9847 70.7585L67.8144 73.7456C67.2151 74.5705 66.0606 74.7534 65.2357 74.1541V74.1541C64.4108 73.5548 64.228 72.4002 64.8273 71.5753L66.9976 68.5882L76.2761 57.0737Z",
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 129.933,
    y: 75.9784,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-4 129.933 75.9784)",
    fill: "#F74A4A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 129.933,
    y: 75.9784,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-4 129.933 75.9784)",
    stroke: "#F2F6FA",
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M144.686 95.0146L150.375 99.9603C152.17 101.521 154.891 101.331 156.452 99.5354V99.5354C158.013 97.7399 157.823 95.019 156.027 93.4582L150.338 88.5125",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M149.562 99.2539V99.2539C150.909 100.425 152.95 100.282 154.12 98.9352L155.533 97.3097C156.704 95.963 156.561 93.9224 155.215 92.7518V92.7518",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M156.452 99.5354L147.512 91.7637",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M155.604 100.511L157.3 98.5603L170.869 109.214L174.12 112.041C175.018 112.821 175.113 114.181 174.333 115.079V115.079C173.553 115.977 172.192 116.072 171.294 115.292L168.043 112.466L155.604 100.511Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M171.219 99.2041C169.317 101.392 165.955 101.585 163.711 99.6337C161.467 97.6827 161.189 94.3271 163.092 92.1389C164.994 89.9506 169.509 86.1239 172.896 89.0678C176.282 92.0116 173.121 97.0158 171.219 99.2041Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M163.442 97.9734L165.393 99.6691L154.739 113.239L151.913 116.49C151.132 117.387 149.772 117.482 148.874 116.702V116.702C147.976 115.922 147.881 114.561 148.661 113.663L151.488 110.412L163.442 97.9734Z",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 83.9784,
    y: 60.9327,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(4 83.9784 60.9327)",
    fill: "#F74A4A"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 83.9784,
    y: 60.9327,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(4 83.9784 60.9327)",
    stroke: "#F2F6FA",
    strokeWidth: 2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9385 81.8379L100.884 87.5272C102.445 89.3228 105.166 89.513 106.961 87.9522V87.9522C108.757 86.3914 108.947 83.6705 107.386 81.875L102.441 76.1857",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M100.178 86.7148V86.7148C101.348 88.0615 103.389 88.2042 104.736 87.0336L106.361 85.6205C107.708 84.4499 107.85 82.4093 106.68 81.0626V81.0626",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M106.961 87.9521L99.1895 79.0117",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M105.986 88.8L107.937 87.1044L119.891 99.5434L122.717 102.794C123.498 103.692 123.403 105.053 122.505 105.833V105.833C121.607 106.613 120.247 106.518 119.466 105.621L116.64 102.369L105.986 88.8Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M121.631 89.6777C119.443 91.58 116.088 91.3026 114.137 89.0582C112.186 86.8138 112.378 83.4523 114.566 81.5501C116.754 79.6478 121.759 76.4869 124.703 79.8734C127.646 83.2599 123.82 87.7755 121.631 89.6777Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M114.101 87.3758L115.797 89.3264L103.358 101.281L100.107 104.107C99.2092 104.888 97.8488 104.792 97.0684 103.895V103.895C96.288 102.997 96.3831 101.636 97.2808 100.856L100.532 98.03L114.101 87.3758Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 92C61 90.8954 61.8954 90 63 90H83.2654C84.2607 90 85.1046 90.7319 85.2453 91.7172L88.7547 116.283C88.8954 117.268 89.7393 118 90.7346 118H191.265C192.261 118 193.105 117.268 193.245 116.283L196.755 91.7172C196.895 90.7319 197.739 90 198.735 90H219C220.105 90 221 90.8954 221 92V118V144C221 145.105 220.105 146 219 146H189H93H63C61.8954 146 61 145.105 61 144V118V92Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 121.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 48.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.5,
    cy: 40.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 7.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 278.5,
    cy: 119.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.5,
    cy: 4.5,
    r: 1.5,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 33 150)",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M215.5 24L235 17.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M232 71.5L250.5 74.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M36 16L55 21",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M20 82.5L36.5 80.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveIntermittentFasting);
export default __webpack_public_path__ + "static/media/collective-intermittent-fasting.f96c957eaae5900fdce86d4dae313dc4.svg";
export { ForwardRef as ReactComponent };